<div
  class="mobile-field-row mobile-field-button"
  [class.user-can-edit]="userCanEdit"
  [class.is-selected]="selected"
  (click)="onSelect()">
  <div class="mobile-field-row-left">
    <app-icon [svg]="icon" [iconWidth]="24" [iconHeight]="24" [iconColor]="EColorPalette.cOrange2"></app-icon>
    <app-fade-text
      class="mobile-field-row-title"
      [text]="label"
      [customStyles]="{
        fontSize: '14px',
        fontWeight: '700',
        color: EColorPalette.cGray3,
        whiteSpace: 'nowrap'
      }"></app-fade-text>
  </div>
  <div class="mobile-field-row-right">
    <app-fade-text
      class="mobile-field-row-value"
      [text]="previewValue"
      [customStyles]="{
        fontSize: '14px',
        fontWeight: '700',
        color: EColorPalette.cGray7,
        whiteSpace: 'nowrap'
      }"></app-fade-text>
    <app-icon
      *ngIf="showAngle"
      [svg]="EIcon.ANGLE_RIGHT"
      [iconWidth]="10"
      [iconHeight]="10"
      [iconColor]="EColorPalette.cGray5"></app-icon>
  </div>
</div>
